<div class="relatorio-container">
    <!-- Cabeçalho -->
    <div class="relatorio-header"
        style="display: flex; align-items: center; gap: 15px; flex-wrap: wrap; justify-content: space-between; width: 100%;">

        <!-- Botões de ações com borda e fundo -->
        <div class="actions-container" 
            style="border: 1px solid #ccc; background-color: #f9f9f9; padding: 10px; border-radius: 5px; width: 100%; display: flex; gap: 10px; flex-wrap: wrap; justify-content: flex-end; align-items: center;">
            <button pButton [label]="'action_view' | transloco" icon="pi pi-eye" (click)="visualizarEtiqueta()" style="min-width: 120px; margin-top: 0.9rem;"></button>
            <button pButton [label]="'action_print' | transloco" icon="pi pi-print" class="p-button-secondary" (click)="imprimir()" style="min-width: 120px; margin-top: 0.9rem;"></button>
            <button pButton [label]="'action_exit' | transloco" icon="pi pi-power-off" class="p-button-danger" (click)="sair()" style="min-width: 120px; margin-top: 0.9rem;"></button>
        </div>
    </div><br>

    <!-- Dropdown de Modelo de Etiqueta -->
    <div class="header-item col-12 md:col-12 m-0 p-0 pr-1 field">
        <label for="modeloEtiqueta">{{ 'etq_label_template' | transloco }}</label>
        <p-dropdown 
            id="modeloEtiqueta" 
            [options]="modeloEtiquetas" 
            optionLabel="descricao"
            [(ngModel)]="selectedModeloEtiqueta" 
            [style]="{ width: '100%' }">
        </p-dropdown>
    </div>

    <!-- Dropdown de Relatório -->
    <div class="relatorio-header" style="flex-wrap: wrap; width: 100%; display: flex;">
        <!-- Dropdown de Relatório -->
        <div class="header-item col-12 md:col-9 m-0 p-0 pr-1 field">
            <label for="relatorio">{{ 'etq_content' | transloco }}</label>
            <p-dropdown id="relatorio" 
                        [options]="etqOptions" 
                        [(ngModel)]="selectedContent" 
                        optionLabel="label" 
                        optionValue="value" 
                        [style]="{ width: '100%' }">
            </p-dropdown>
        </div>


        <!-- Input com Label -->
        <div class="header-item col-12 md:col-3 m-0 p-0 pr-1 field">
            <label for="relatorio">{{ 'etq_copy' | transloco }}</label>
            <p-inputNumber [(ngModel)]="copias" mode="decimal" [showButtons]="true" inputId="minmax-buttons" style="width: 100%;" [min]="1" [max]="100"></p-inputNumber>
        </div>
    </div>
</div>
